import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {

  constructor() { }
  authenticateAccount(){
    const storageData = JSON.parse(localStorage.getItem('loginuser'));
    //console.log(storageData);
    if(storageData != null){
      if(storageData.role == 'admin') {
        return true;
      }
    }else{
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/auth.service.ts